import React, { useEffect, useState } from 'react';
import TestSteps from './TestSteps';
import { useUserContext } from 'src/context/UserProvider';
import { MeetingType } from 'types';
import PreferenceSelection from './PreferenceSelection';
import { useNavigate } from 'react-router-dom';
import MockTestSection from './MockTestSection';

export enum LeftSectionUI {
	userPreference = 'userPreference',
	mandatoryFormData = 'mandatoryFormData',
	testSteps = 'testSteps',
	mockTest = 'mockTest',
}

const LeftSection = () => {
	const { user, leftSectionUI, setLeftSectionUI, setInterviewType } = useUserContext();
	const navigate = useNavigate();
	const [isMandatoryFormDataFilled, setIsMandatoryFormDataFilled] = useState(false);
	const [isUserPreferenceFilled, setIsUserPreferenceFilled] = useState(false);

	useEffect(() => {
		if (user?.userPreference?.careerPath && user?.userPreference?.developmentRole && user?.userPreference?.techStack) {
			setIsUserPreferenceFilled(true);
		} else {
			setIsUserPreferenceFilled(false);
		}
	}, [user?.userPreference]);

	const handleStartTest = (meetingType?: MeetingType) => {
		if (meetingType) {
			setInterviewType(meetingType);
		}

		setLeftSectionUI(LeftSectionUI.userPreference);
		// if (isUserPreferenceFilled) {
		// 	if (isMandatoryFormDataFilled) {
		// 		// start test flow
		// 	} else {
		// 		// navigate('/benchmarking/mandatory-form');
		// 	}
		// } else {
		// 	// show user preference
		// 	setLeftSectionUI(LeftSectionUI.userPreference);
		// }
	};

	const getLeftSectionUI = () => {
		switch (leftSectionUI) {
			case LeftSectionUI.userPreference:
				return <PreferenceSelection handleStartTest={handleStartTest} />;
			case LeftSectionUI.testSteps:
				return <TestSteps handleStartTest={handleStartTest} />;
			case LeftSectionUI.mockTest:
				return <MockTestSection />;
			default:
				return null;
		}
	};

	return <div className="h-[100%] ">{getLeftSectionUI()}</div>;
};

export default LeftSection;
